
export const AuthParacetamol = ({ auth, handleChange, error }) => {
  return (<>
    <div className="row">
    <div className="col col-12 ">
      <h4>
      Autorització per a l’administració de paracetamol
      </h4>
      <p>
        <input type="checkbox" id="authParacetamol" name="authParacetamol" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
        <label htmlFor="authParacetamol"> AUTORITZO  El centre educatiu a administrar paracetamol al meu fill/a, en cas de presentar febre superior a 38℃ de temperatura corporal mentre s’espera l’arribada d’algun familiar que el pugui portar a casa. </label>
        <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
      </p>

    </div>
  </div>

    <br />
  </>)
}
